import { Instagram, Youtube, Facebook, Mail, Phone, MapPin } from 'lucide-react';
import vpmLogo from '@/assets/vpm-logo.png';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  const socialLinks = [
    { icon: Instagram, href: 'https://www.instagram.com/_vantagepointmedia?igsh=MWJod281cHN0cHlnNQ==', label: 'Instagram' },
    { icon: Youtube, href: 'https://youtube.com/@shaytalton8709?si=1SrS0o0ta09LsUmE', label: 'YouTube' },
    { icon: Facebook, href: 'https://www.facebook.com/share/1C7d4c4Xcn/?mibextid=wwXIfr', label: 'Facebook' },
  ];

  const quickLinks = [
    { label: 'Services', href: '#services' },
    { label: 'Results', href: '#results' },
    { label: 'Process', href: '#process' },
    { label: 'Testimonials', href: '#testimonials' },
    { label: 'Portfolio', href: '/portfolio' },
  ];

  const services = [
    'Social Media Management',
    'Video Production',
    'Content Strategy',
    'Brand Photography',
    'Ad Management',
  ];

  return (
    <footer className="bg-foreground text-background">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 py-10 sm:py-16">
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-8 sm:gap-12">
          {/* Brand Column */}
          <div className="col-span-2 lg:col-span-1">
            <div className="mb-4 sm:mb-6">
              <img 
                src={vpmLogo} 
                alt="VPM Media" 
                className="h-10 sm:h-12 w-auto"
              />
            </div>
            <p className="text-background/70 mb-4 sm:mb-6 leading-relaxed text-sm sm:text-base">
              Central Ohio's premier video production and social media agency. Helping professionals build trust and attract high-value clients.
            </p>
            <div className="flex gap-3 sm:gap-4">
              {socialLinks.map((social) => (
                <a
                  key={social.label}
                  href={social.href}
                  aria-label={social.label}
                  className="w-9 h-9 sm:w-10 sm:h-10 bg-background/10 rounded-lg flex items-center justify-center hover:bg-primary hover:text-primary-foreground transition-colors"
                >
                  <social.icon className="w-4 h-4 sm:w-5 sm:h-5" />
                </a>
              ))}
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="font-display font-semibold text-base sm:text-lg mb-4 sm:mb-6">Quick Links</h4>
            <ul className="space-y-2 sm:space-y-3">
              {quickLinks.map((link) => (
                <li key={link.label}>
                  <a
                    href={link.href}
                    className="text-background/70 hover:text-primary transition-colors text-sm sm:text-base"
                  >
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Services */}
          <div>
            <h4 className="font-display font-semibold text-base sm:text-lg mb-4 sm:mb-6">Services</h4>
            <ul className="space-y-2 sm:space-y-3">
              {services.map((service) => (
                <li key={service}>
                  <span className="text-background/70 text-sm sm:text-base">{service}</span>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact */}
          <div className="col-span-2 lg:col-span-1">
            <h4 className="font-display font-semibold text-base sm:text-lg mb-4 sm:mb-6">Contact</h4>
            <ul className="space-y-3 sm:space-y-4">
              <li className="flex items-start gap-3">
                <MapPin className="w-4 h-4 sm:w-5 sm:h-5 text-primary flex-shrink-0 mt-0.5" />
                <span className="text-background/70 text-sm sm:text-base">
                  Central Ohio
                </span>
              </li>
              <li className="flex items-center gap-3">
                <Mail className="w-4 h-4 sm:w-5 sm:h-5 text-primary flex-shrink-0" />
                <a
                  href="mailto:shay@vantagepointmediagroup.com"
                  className="text-background/70 hover:text-primary transition-colors text-xs sm:text-base break-all"
                >
                  shay@vantagepointmediagroup.com
                </a>
              </li>
              <li className="flex items-center gap-3">
                <Phone className="w-4 h-4 sm:w-5 sm:h-5 text-primary flex-shrink-0" />
                <a
                  href="tel:+16146250865"
                  className="text-background/70 hover:text-primary transition-colors text-sm sm:text-base"
                >
                  (614) 625-0865
                </a>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="mt-8 sm:mt-12 pt-6 sm:pt-8 border-t border-background/10">
          <div className="flex flex-col sm:flex-row justify-between items-center gap-3 sm:gap-4">
            <p className="text-background/60 text-xs sm:text-sm">
              © {currentYear} Vantage Point Media. All rights reserved.
            </p>
            <div className="flex gap-4 sm:gap-6 text-xs sm:text-sm">
              <a href="#" className="text-background/60 hover:text-primary transition-colors">
                Privacy Policy
              </a>
              <a href="#" className="text-background/60 hover:text-primary transition-colors">
                Terms of Service
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
